import React from 'react';
import PersistentAlert from './PersistentAlert';  

export const WarningMessage = ({ text = "NOTE: These are shipped quantities only, not paid units. Particularly for newer releases, these figures may not be net of returns. Do not use this information for royalty reporting, and use caution when incorporating it into projections. \n The ShipDB data set for Bloomington direct sales is available from August 2020 onwards. In other territories, the data set may be limited to the length of time we have been working with a given distribution partner. For that reason, global LTD totals for older titles will not always reflect actual ship to date." }) => {
  return (
	  <PersistentAlert
		  message={<span style={{ textAlign: 'left', display: 'inline-block', whiteSpace: 'pre-line' }}>{text}</span>}
		  // description="This is the custom black background alert with white text."
		  type="warning" 
		  id="data_warning"
		  styles={{
			// Style for the main alert container (background)
			root: {
			  backgroundColor: 'black', // Black background
			  borderColor: 'gray',      // Optional: Add a subtle border
			},
			message: { 
			  textAlign: 'left' 
		    },
			// Style for the main title/message text
			title: {
			  color: 'white', // White text
			},
			// Style for the secondary description text
			description: {
			  color: 'white', // White text
			  textAlign: 'left'
			},
			// Style for the icon (optional, to ensure it's visible)
			icon: {
			  color: 'white', 
			}
		  }}
		/>
  );
};
